module.exports = "/legacy/c3f3d7f2008689b7ec2c4d57177422bd.svg";